import { z } from 'zod'

export const PrintingStatusEnum = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
} as const

const printingStatusUnion = z.union([
  z.literal(PrintingStatusEnum.SUCCESS),
  z.literal(PrintingStatusEnum.ERROR)
])

export const printingStatusDto = z.object({
  status: printingStatusUnion, // 'SUCESS' means connection to printer, not succesfull printing...
  finishedPaperError: z.boolean(),
  nearFinishedPaperWarning: z.boolean(),
  openDeckError: z.boolean(),
  sensorError: z.boolean()
})

export type PrintingStatus = z.infer<typeof printingStatusDto>
